/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathFunctionIcon16Solid = forwardRef('MathFunctionIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 7.036v3.06c0 1.184-.96 2.143-2.143 2.143h-.055a1 1 0 1 0 0 2h.055A4.143 4.143 0 0 0 7 10.096v-3.06h2a1 1 0 0 0 0-2H7.107a2.144 2.144 0 0 1 2.037-1.474h.466a1 1 0 0 0 0-2h-.466a4.144 4.144 0 0 0-4.09 3.474H3.879a1 1 0 1 0 0 2H5Z" }),
        React.createElement("path", { d: "M14.074 9.56a.9.9 0 1 0-1.272-1.272l-1.52 1.52-1.52-1.52A.9.9 0 0 0 8.489 9.56l1.52 1.52-1.52 1.52a.9.9 0 0 0 1.273 1.272l1.52-1.52 1.52 1.52a.9.9 0 0 0 1.272-1.273l-1.52-1.52 1.52-1.52Z" })));
});
